export default {
  viewData: 'DỮ LIỆU',
  viewChart: 'BIỂU ĐỒ',
  allTime: 'Tất Cả',
  recentYear5: '5 Năm',
  recentYear10: '10 Năm',
  timeRange: 'Khoảng thời gian:',
  from: 'Từ',
  to: 'Đến',
  present: 'Hiện tại',
  averageReturn: 'Lợi Nhuận TB',
  daily: 'Theo Ngày',
  monthly: 'Theo Tháng',
  quarterly: 'Theo Quý',

  monday: 'Thứ 2',
  tuesday: 'Thứ 3',
  wednesday: 'Thứ 4',
  thursday: 'Thứ 5',
  friday: 'Thứ 6',

  january: 'Tháng 1',
  february: 'Tháng 2',
  march: 'Tháng 3',
  april: 'Tháng 4',
  may: 'Tháng 5',
  june: 'Tháng 6',
  july: 'Tháng 7',
  august: 'Tháng 8',
  september: 'Tháng 9',
  october: 'Tháng 10',
  november: 'Tháng 11',
  december: 'Tháng 12',

  quarter1: 'Quý 1',
  quarter2: 'Quý 2',
  quarter3: 'Quý 3',
  quarter4: 'Quý 4',

  q1: 'Q1',
  q2: 'Q2',
  q3: 'Q3',
  q4: 'Q4',

  listFilterDatetime: {
    day: 'Ngày',
    month: 'Tháng',
    quarter: 'Qúy',
  },

  marketAnomalyTable: {
    YEAR: 'NĂM',
    MONDAY: 'THỨ 2',
    TUESDAY: 'THỨ 3',
    WEDNESDAY: 'THỨ 4',
    THURSDAY: 'THỨ 5',
    FRIDAY: 'THỨ 6',
    JANUARY: 'THÁNG 1',
    FEBRUARY: 'THÁNG 2',
    MARCH: 'THÁNG 3',
    APRIL: 'THÁNG 4',
    MAY: 'THÁNG 5',
    JUNE: 'THÁNG 6',
    JULY: 'THÁNG 7',
    AUGUST: 'THÁNG 8',
    SEPTEMBER: 'THÁNG 9',
    OCTOBER: 'THÁNG 10',
    NOVEMBER: 'THÁNG 11',
    DECEMBER: 'THÁNG 12',
    QUARTER_ONE: 'QÚY 1',
    QUARTER_TWO: 'QUÝ 2',
    QUARTER_THREE: 'QUÝ 3',
    QUARTER_FOUR: 'QUÝ 4',
  },
  Average: 'Trung bình',
};
